import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import useCheckAuth from './useCheckAuth.js';
import ROUTES from '../../routes/Routes.js';
import { loginUser, logoutUser } from '../../services/auth/loginService.js';
import { isUsernameValid } from '../../utils/validations/loginValidations.js';

// Toda la logica
export const useLogin = () => {
    const [form, setForm] = useState({
        username: '',
        password: ''
    });

    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [validationErrors, setValidationErrors] = useState([]);
    const clearValidationErrors = () => setValidationErrors([]);
    const navigate = useNavigate();
    const location = useLocation();
    const { isAuthenticated, setIsAuthenticated, loading } = useCheckAuth();

    const from = location.state?.from?.pathname || ROUTES.HOME;

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const submit = async () => {
        // Limpieza global
        setError('');
        setSuccess('');
        setValidationErrors([]);

        if (!isUsernameValid(form.username)) {
            setError('El campo username solo puede contener letras y números.');
            return;
        }

        try {
            await loginUser(form);
            setSuccess('Inicio de sesión exitoso');
            navigate(from);
        } catch (err) {
            // Validación del archivo: middleware/validator.js del backend
            if (err.response?.status === 400 && Array.isArray(err.response.data?.errors)) {
                setValidationErrors(err.response.data.errors);
                return;
            }
            // Error general
            setError(
                err.response?.data?.message ||
                'Error al iniciar sesión. Intente más tarde.'
            );
        }
    };

    const logout = async () => {
        try {
            await logoutUser();
            setIsAuthenticated(false);
            navigate(ROUTES.LOGIN);
        } catch {
            setError('Error al cerrar sesión.');
        }
    };

    return {
        form,
        error,
        success,
        validationErrors,
        isAuthenticated,
        loading,
        handleChange,
        submit,
        logout,
        clearValidationErrors
    };
};
